<div class="container-fluid sticky-header">
    <div class="row">
        <div class="col-sm-12 col-lg-12 logoImg"> 
            <div class="container-fluid py-1"><img class="" src="../../assets/images/logo.svg" alt="" > </div>
        </div>
    </div>
</div>
<div class="paddingLogin py-3">
    <div class="col-4 offset-4 otpDiv">
        <div *ngIf="showOtpNotification" class="mb-4 otpnotify">
            <span *ngIf="!ifResend && !wrongOtp && !ifReachAttempt">Please enter the OTP sent to your registered email ID.</span>
            <span *ngIf="ifResend && !ifReachAttempt">The OTP has been re-sent to your registered email ID.</span>
            <span *ngIf="ifReachAttempt">You have exceeded the maximum attempts, please click on registration link to generate a new OTP.</span>
            <span *ngIf="wrongOtp && !ifReachAttempt">Incorrect OTP. Please try again.</span>
        </div>
        <div *ngIf="expiredOtp" class="mb-4 otpnotify">
            <span>The OTP has expired, and it has to be generated again.</span>
        </div>
        <form [formGroup]="otpForm">
            <div class="mb-2" *ngIf="otpGenerated">
                <input type="text" class="form-control" id="otp" placeholder="Enter OTP" formControlName="otp" maxlength="6" (keydown)="checkNumber($event)">
            </div>
           
            <button type="button" class="w-100 btn btn-lg btn-primary otpBtn" type="submit" (click)="verifyIfRegistered('generateOtp')" *ngIf="!otpGenerated">
                <span>Generate OTP</span>
            </button>
            
            <button type="button" class="w-100 btn btn-lg btn-primary otpBtn" type="submit" (click)="verifyIfRegistered('verifyOtp')" *ngIf="otpGenerated">
                <span>Verify OTP</span>
            </button>
            
            <button type="button" class="w-100 btn btn-lg btn-primary mt-2 otpBtn" type="submit" (click)="verifyIfRegistered('resendOtp')" *ngIf="otpGenerated">
                <span>Resend OTP</span>
            </button>

            <div class="otpNote mt-1">
                <span *ngIf="!otpGenerated">* Please click on 'Generate OTP' button to receive the OTP in your registered email address.</span>
                <span *ngIf="otpGenerated">* Please click on 'Resend OTP' button to send the OTP again to your registered email address.</span>
            </div>
            <div class="rightTime" *ngIf="timerOn">
                Time Left :&nbsp; <span>{{mnt}}m {{sec}}s</span>
            </div>
        </form>
    </div>
</div>
<div class="footerDiv">
    <app-footer></app-footer>
</div>